import { useEffect } from "react";

export default function AlertError() {
    const message = sessionStorage.getItem("message");

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            sessionStorage.removeItem("error");
            const alertDiv = document.getElementById("alert");
            if (alertDiv) {
                while (alertDiv.firstChild) {
                    alertDiv.removeChild(alertDiv.firstChild);
                }
            }
        }, 25000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    const closeAlert = () => {
        sessionStorage.removeItem("error");
        const alertDiv = document.getElementById("alert");
        if (alertDiv) {
            while (alertDiv.firstChild) {
                alertDiv.removeChild(alertDiv.firstChild);
            }
        }
    };

    return (
        <div id={"alert"}>
            <div className="alert alert-danger alert-dismissible" role="alert">
                {message}
                <button
                    type="button"
                    className="btn-close"
                    onClick={closeAlert}
                    data-bs-dismiss="alert"
                    aria-label="Close"
                ></button>
            </div>
        </div>
    );
}